import { PopoverScopeContext as e } from "./PopoverGroup.js";
import { useCallback as t, useContext as n, useEffect as r, useId as i, useState as a } from "react";
//#region src/components/popover/usePopoverState.ts
function o(o) {
	let [s, c] = a(o.defaultOpen ?? !1), [l, u] = a(!0), d = o.open ?? s, f = i(), p = n(e), m = o.onOpenChange, h = t((e) => {
		c(e), m?.(e);
	}, [m]);
	return r(() => (d && p?.activate(f, () => {
		h(!1);
	}), () => {
		p?.release(f);
	}), [
		d,
		f,
		p,
		h
	]), {
		open: d,
		animate: l,
		change: h,
		dismiss: (e) => {
			u(!e.type.startsWith("key") && e.detail !== 0), h(!1);
		},
		handleOpenChange: (e, t) => {
			u(!t.event.type.startsWith("key") && !(t.event instanceof MouseEvent && t.event.detail === 0)), h(e);
		}
	};
}
//#endregion
export { o as usePopoverState };
